import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";

const createApi = (tenantKey: string) =>
	axios.create({
		baseURL: `${url}/${tenantKey}/phases`,
		...AuthHeader,
	});

export const getPhases = (tenantKey: any, filter: any = {}) => {
	const api = createApi(tenantKey);
	const _filter = { ...filter, is_removed: false };
	return new Promise((resolve, reject) => {
		api
			.get("/", { params: { filter: _filter } })
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const getPhasesAndTasks = (
	tenantKey: any,
	filter: any = {},
	operation_id: any = null
) => {
	const api = createApi(tenantKey);
	const _filter = { ...filter, is_removed: false };
	console.log("filter", _filter);
	return new Promise((resolve, reject) => {
		api
			.get("/getPhasesTasks", {
				params: {
					filter: _filter,
					option: {},
					sort: { sequence_id: 1 },
					operation_id: operation_id, // for multi-asset operations' tasks
				},
			})
			.then((_data: any) => {
				if (_data?.data) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				console.log(e);
				reject(e);
			});
	});
};

/**
 *
 * @param tenantKey tenant key to select the database
 * @param data data to be added
 * @param user current user
 * @returns data added
 */
export const addPhaseItem = (tenantKey: any, data: any, user: any) => {
	const api = createApi(tenantKey);
	// data added is being filtered by phase_name and operation_code to avoid duplication
	return new Promise((resolve, reject) => {
		api
			.get("/", {
				params: {
					filter: {
						phase_name: data.phase_name,
						operation_code: data.operation_code,
					},
				},
			})
			.then((result: any) => {
				if (result.data.length > 0) {
					reject({
						code: 11000,
						keyPattern: {
							phase_name: "",
						},
					});
				} else {
					api
						.post("/add", { data, user })
						.then((_data: any) => {
							resolve(_data.data);
						})
						.catch((e: any) => {
							reject(e?.response?.data?.error);
						});
				}
			});
	});
};

export const addMultiAssetsPhase = (tenantKey: any, data: any, user: any) => {
	const api = createApi(tenantKey);
	return new Promise((resolve, reject) => {
		api
			.get("/", {
				params: {
					filter: {
						phase_name: data.phase_name,
						project_id: data.project_id,
					},
				},
			})
			.then((result: any) => {
				console.log("Result", result);
				if (result.data.length > 0) {
					reject({
						code: 11000,
						keyPattern: {
							phase_name: "",
						},
					});
				} else {
					api
						.post("/addMultiAssetsPhase", { data, user })
						.then((_data: any) => {
							resolve(_data.data);
						})
						.catch((e: any) => {
							reject(e?.response?.data?.error);
						});
				}
			});
	});
};

export const updatePhaseItem = (
	tenantKey: any,
	id: any,
	data: any,
	initialData: any,
	user: any,
	formList: any = null
) => {
	const api = createApi(tenantKey);
	return new Promise((resolve, reject) => {
		console.log(id, data);
		api
			.get("/", {
				params: {
					filter: {
						_id: { $ne: id },
						phase_name: data.phase_name,
						operation_code: data.operation_code,
					},
				},
			})
			.then((result: any) => {
				if (result.data.length > 0) {
					reject({
						code: 11000,
						keyPattern: {
							phase_name: "",
						},
					});
				} else {
					api
						.put("/update", {
							filter: { _id: id },
							data,
							initialData,
							user,
							formList,
							options: { upsert: true, new: true },
						})
						.then((_data: any) => {
							resolve(_data.data);
						})
						.catch((e: any) => {
							reject(e?.response?.data?.error);
						});
				}
			});
	});
};

export const phasesReorder = (
	tenantKey: any,
	data: any,
	initialData: any,
	user: any,
	formList: any = null,
	extraData: any = null
) => {
	const api = createApi(tenantKey);
	return new Promise((resolve, reject) => {
		api
			.put("/phasesReorder", {
				data,
				initialData,
				user,
				formList,
				options: { upsert: true, new: true },
				extraData,
			})
			.then((_data: any) => {
				resolve(_data.status);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const updatePhaseDisabled = (
	tenantKey: any,
	id: any,
	data: any,
	user: any
) => {
	const api = createApi(tenantKey);
	return new Promise((resolve, reject) => {
		console.log(id, data);
		api
			.put("/disable", {
				filter: { _id: id },
				data,
				user,
				options: { upsert: true, new: true },
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const deletePhaseItem = (
	tenantKey: any,
	id: any,
	data: any,
	user: any
) => {
	const api = createApi(tenantKey);
	return new Promise((resolve, reject) => {
		api
			.post("/delete", {
				filter: {
					filter: {
						_id: id,
					},
					data: data,
					user: user,
				},
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

export const getPhaseItem = (tenantKey: any, id: any) => {
	const api = createApi(tenantKey);
	return new Promise((resolve, reject) => {
		api
			.get("/", {
				params: {
					filter: {
						_id: id,
					},
				},
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
